import React from 'react';
import Head from 'next/head';

interface Props {
    metaTitle: string;
}

const MetaLayout = ({ metaTitle, children }: React.PropsWithChildren<Props>) => (
    <>
        <Head>
            <title>{metaTitle}</title>
        </Head>
        {children}
    </>
);

export default MetaLayout;
